export interface PainPoint {
  title: string
  body: string
}

export const painPoints: PainPoint[] = [
  {
    title: '😰 UNE IMAGE À L’ÉCRAN… SANS SAVOIR PAR OÙ COMMENCER',
    body: 'Radio, scanner ou IRM : tout est là, mais sans ordre de lecture, l’œil se promène au hasard et les détails importants passent inaperçus.',
  },
  {
    title: '🔍 NORMAL, VARIANTE OU ANOMALIE À SIGNALER ?',
    body: 'Une variante anatomique, une densité inhabituelle, un signal différent : sans repères clairs, le doute s’installe et on hésite à signaler.',
  },
  {
    title: '⚠️ UN CLICHÉ À REFAIRE, UN ARTEFACT TROMPEUR',
    body: 'Rotation, cadrage, mouvement ou artefact technique : un mauvais positionnement peut masquer un détail ou en créer un faux.',
  },
  {
    title: '📚 DES SUPPORTS DISPERSÉS PARTOUT',
    body: 'Cours, polycopiés, notes de stage, protocoles du service : l’information existe, mais jamais au moment où vous êtes devant l’image.',
  },
]
